module.exports = __webpack_public_path__ + "static/img/description-raan-phasing-example-1.99cab1e.png";